// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the HandlerModels.tst template. 
// !!Do not modify this file or change may be lost!!
// GetSecondaryProgramCourseDetailsHandler
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';
import SecondaryProgramCourseDTO from '../models/SecondaryProgramCourseDTO';
import ResultDTO from '../models/ResultDTO';

interface Request {
    id: string | null;
}

const Request = {
    create: (initValues?: Partial<Request> | Record<string, unknown> | null) => {
        return Object.assign(
        {
            id: '00000000-0000-0000-0000-000000000000',
        },
        initValues);
    },
    id: 'id',
}

interface Result extends ResultDTO {
    secondaryProgramCourse: SecondaryProgramCourseDTO | null;
}

const Result = {
    create: (initValues?: Partial<Result> | Record<string, unknown> | null) => {
        return Object.assign(ResultDTO.create(),
        {
            secondaryProgramCourse: null,
        },
        initValues);
    },
    secondaryProgramCourse: 'secondaryProgramCourse',
}

export { Request, Result };